/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-supplier.reducer';

export const DiagLabSupplierDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabSupplierEntity = useAppSelector(state => state.diagLabSupplier.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabSupplierDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabSupplier.detail.title">DiagLabSupplier</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.id}</dd>
          <dt>
            <span id="supplierName">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.supplierName">Supplier Name</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.supplierName}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.taxCode}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabSupplier.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabSupplierEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabSupplier.contactCode">Contact Code</Translate>
          </dt>
          <dd>{diagLabSupplierEntity.contactCode ? diagLabSupplierEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabSupplier.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabSupplierEntity.diagLab ? diagLabSupplierEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-supplier" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-supplier/${diagLabSupplierEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabSupplierDetail;
